import { render, staticRenderFns } from "./DigiLine.vue?vue&type=template&id=5d31ed14&scoped=true"
import script from "./DigiLine.vue?vue&type=script&lang=js"
export * from "./DigiLine.vue?vue&type=script&lang=js"
import style0 from "./DigiLine.vue?vue&type=style&index=0&id=5d31ed14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31ed14",
  null
  
)

export default component.exports